import { render } from "./EnrollmentAppliedDiscounts.vue?vue&type=template&id=393b705c&ts=true"
import script from "./EnrollmentAppliedDiscounts.vue?vue&type=script&lang=ts"
export * from "./EnrollmentAppliedDiscounts.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__